import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { PassReset } from '../../../core/model/pass-reset';
import { MessageService } from 'src/app/core/services/message.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-pass-reset',
  templateUrl: './pass-reset.component.html',
  styleUrls: ['./pass-reset.component.scss']
})
export class PassResetComponent implements OnInit {
  @Input() visible = false;
  @Output() visible_ = new EventEmitter<boolean>();
  isLoading = false;
  subs: Subscription = new Subscription();
  resetForm: FormGroup;
  passReset: PassReset = new PassReset();
  constructor(private ref: ChangeDetectorRef, private formBuilder: FormBuilder,
    private msgService: MessageService, private userService: UserService) {
  }

  ngOnInit(): void {
    this.resetForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required, Validators.pattern('(?=.*[A-Z])[A-Za-z0-9\d$@$!%*?&].{5,}')]],
      password: ['', [Validators.required, Validators.pattern('(?=.*[A-Z])[A-Za-z0-9\d$@$!%*?&].{5,}')]],
      confirmPassword: ['', [Validators.required, Validators.pattern('(?=.*[A-Z])[A-Za-z0-9\d$@$!%*?&].{5,}')]],
    });
    this.resetForm.reset();
  }
  editPass() {
    // e.preventDefault();
    if (this.resetForm.invalid) {
      for (const i in this.resetForm.controls) {
        this.resetForm.controls[i].markAsDirty();
        this.resetForm.controls[i].updateValueAndValidity();
      }
      return;
    }
    if(this.val.password.value !== this.val.confirmPassword.value) {
      this.msgService.message('error', 'Password and Confirm Password should be same!');
      return;
    }
    let passReset: PassReset = new PassReset();
    passReset.password = this.val.password.value;
    passReset.oldPassword = this.val.oldPassword.value;
    passReset.confirmPassword = this.val.confirmPassword.value;
    this.subs.add(this.userService.passResetUser(passReset).subscribe((res: HttpResponse<any>) => {
      if (res.status == 200) {
        if (res.body.returnCode == 1) {
          this.close();
          this.resetForm.reset();
          this.isLoading = false;
          this.msgService.notify('success', 'Successed', 'Password updated!');
          this.ref.detectChanges();
        } else {
          this.msgService.notify('error', 'Error', res.body.returnMsg);
        }
      }
    }))
  }
  get val() {
    return this.resetForm.controls;
  }
  open(): void {
    this.visible = true;
  }
  close(): void {
    this.resetForm.reset();
    this.visible = false;
    this.visible_.emit(this.visible);
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
